import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { CreatableMultiSelect } from '.';
import { CustomClearIcon, CustomLoadingIndicator, CustomLoadingMessage, CustomMultiValueRemove } from './CustomComponents';
export { default as TagInputField } from './TagInputField';
const TagInput = ({ value, onChange, disabled, error, formatInputValue = (val) => val, onBlur, ...props }) => {
    const [inputValue, setInputValue] = useState();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const createOption = useCallback((label) => ({
        label,
        value: label,
    }), []);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleChange = useCallback((val) => {
        onChange(val);
    }, [onChange]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleInputChange = useCallback((inputVal) => {
        setInputValue(formatInputValue(inputVal));
    }, [formatInputValue]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const updateTags = useCallback(() => {
        if (!inputValue)
            return;
        setInputValue('');
        if (value && Array.isArray(value)) {
            if (value.some((option) => option.value === inputValue)) {
                return;
            }
            onChange([...value, createOption(inputValue)]);
        }
        else {
            onChange([createOption(inputValue)]);
        }
    }, [createOption, inputValue, onChange, value]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleKeyDown = useCallback((event) => {
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                updateTags();
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [updateTags]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleBlur = useCallback((event) => {
        if (onBlur)
            onBlur(event);
        updateTags();
    }, [onBlur, updateTags]);
    return (_jsx(CreatableMultiSelect, { components: {
            DropdownIndicator: null,
            ClearIndicator: CustomClearIcon,
            LoadingIndicator: CustomLoadingIndicator,
            LoadingMessage: CustomLoadingMessage,
            MultiValueRemove: CustomMultiValueRemove,
        }, inputValue: inputValue, isClearable: true, isDisabled: disabled, menuIsOpen: false, onInputChange: handleInputChange, onKeyDown: handleKeyDown, onChange: handleChange, value: value, error: error, onBlur: handleBlur, ...props }));
};
export default TagInput;
